import ArticleShareItem from './code/Scripts/components/article-share-item.vue';
import CookieBanner from './code/Scripts/components/cookie-banner.vue';

export default {
  components: {
    ArticleShareItem,
    CookieBanner,
  },
};
